import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { utils } from 'gipsy-misc'

import { getElementNotificationsType } from 'features/notifications/utils'

const mapStateToProps = state => ({
  session: state.session,
  notifications: state.notifications.list
})

export default function wrapper(Component) {
  class LineContainer extends PureComponent {
    static propTypes = {
      session: PropTypes.object.isRequired,
      onComplete: PropTypes.func,
      onChange: PropTypes.func,
      onClick: PropTypes.func,
      item: PropTypes.object.isRequired,
      highlight: PropTypes.bool,
      index: PropTypes.number,
      showWhenDate: PropTypes.bool,
      hideCompleted: PropTypes.number,
      animationDuration: PropTypes.number,
      isDraggable: PropTypes.bool,
      hideDraggableCell: PropTypes.bool,
      isInOnboarding: PropTypes.bool,
      group: PropTypes.string
    }

    static defaultProps = {
      hideCompleted: 1,
      animationDuration: 2000
    }

    componentWillUnmount = () => {
      clearInterval(this.timer)
    }

    onClick = () => {
      if (this.props.onClick) {
        this.props.onClick(this.props.item.id, this.props.item.type, this.props.item.webLink)
      }
    }

    onComplete = data => {
      if (this.props.onComplete) {
        this.props.onComplete(data)
      }
    }

    onChange = (taskId, data) => {
      if (this.props.onChange) {
        this.props.onChange(taskId, data)
      }
    }

    getElementNotificationsType = () => {
      const { notifications, item } = this.props
      return getElementNotificationsType(notifications, 'task', item.id)
    }

    getRelatedNotifications = () => {
      const { notifications, item } = this.props
      return utils.notifications.getNotificationsByTaskId(notifications, item.id)
    }

    render() {
      const {
        session,
        item,
        highlight,
        showWhenDate,
        isDraggable,
        hideDraggableCell,
        isInOnboarding,
        group
      } = this.props
      const notificationsType = this.getElementNotificationsType()
      const notifications = this.getRelatedNotifications()
      return (
        <Component
          ref={ref => (this.el = ref)}
          session={session}
          onClick={this.onClick}
          onComplete={this.onComplete}
          onChange={this.onChange}
          hideDraggableCell={hideDraggableCell}
          isDraggable={!!isDraggable}
          showWhenDate={showWhenDate}
          notificationsType={notificationsType}
          notifications={notifications}
          isInOnboarding={isInOnboarding}
          item={item}
          highlight={highlight}
          group={group}
        />
      )
    }
  }

  const containerRedux = connect(
    mapStateToProps,
    null,
    null,
    { pure: true }
  )(LineContainer)

  return containerRedux
}



// WEBPACK FOOTER //
// ./src/features/list/components/line/container.js